import Button from "../../../components/Button";
import Input from "../../../components/Input/InputSignUp";
import Select from 'react-select'
import MaskInput from "../../../components/Input/MaskInput";
import {alert} from "../../../components/Alert";
import { MdEmail, MdLock, MdPhone } from "react-icons/md";
import { Container } from "../../SignUpPage/styles";

import { useHistory } from "react-router-dom";
import { useState, useEffect } from 'react'
import { api } from "../../../services/api";

const RetailerCreate = () => {

  // Account by CPF
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password_confirmation, setPassword_confirmation] = useState("");
  const [name, setName] = useState("");
  const [cpf, setCpf] = useState("");
  const [cep, setCep] = useState("");
  const [phone, setPhone] = useState("");
  const [rg, setRg] = useState("");
  const [person_type, setPerson_type] = useState('individual')
  const [ddd, setDdd] = useState('')
  const [street, setStreet] = useState('')
  const [street_number, setStreet_number] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [states, setStates] = useState([]);
  const [banks, setBanks] = useState([]);
  const [optionStates, setOptionStates] = useState([]);
  const [options_bank, setOptionBanks] = useState([]);
  const [neighborhood, setNeighborhood] = useState('')

  // // Account by CNPJ
  const [cnpj, setCnpj] = useState("");
  const [fantasy_name, setFantasy_name] = useState("");
  const [social_name, setSocial_name] = useState("");
  const [icms_contribution, setIcms_contribution] = useState("");
  const [national_simple, setNational_simple] = useState(false);
  const [state_registration, setState_registration] = useState("");
  const [municipal_registration, setMunicipal_registration] = useState("");
  
  // Info about bank
  const [bank, setBank] = useState("");
  const [branch_number, setBranch_number] = useState("");
  const [branch_check_digit, setBranch_check_digit] = useState("");
  const [account_number, setAccount_number] = useState("");
  const [account_check_digit, setAccount_check_digit] = useState("");
  const [account_type, setAccount_type] = useState("");

  const options_person_type = [
    { value: 'individual', label: 'Pessoa Física'},
    { value: 'company', label: 'Pessoa Jurídica'}
  ]

  const options_icms_contribution = [
    { value: 'Contribuinte ICMS', label: 'Contribuinte ICMS'},
    { value: 'Contribuinte Isento de ICMS', label: 'Contribuinte Isento de ICMS'},
    { value: 'Não Contibuinte', label: 'Não Contibuinte'}
  ]

  const options_account_type = [
    { value: 'checking', label: 'Conta Corrente'},
    { value: 'savings', label: 'Poupança'}
  ]

  function changeICMStype(value) {
    setIcms_contribution(value);
    setNational_simple(false);
  }

  useEffect(() => {
    api.get('states').then((response) => {
        setStates(response.data);
    })
  },[])

  useEffect(() => {
    setOptionStates(states.map((state) => {
      return { value: state.abbreviation, label: state.name }
    }))
  }, [states, state])

  useEffect(() => {
    fetch("https://guibranco.github.io/BancosBrasileiros/data/bancos.json")
    .then((response) => response.json()).then((data) => {
        setBanks(data);
        console.log(data)
    })
  },[])

  useEffect(() => {
    setOptionBanks(banks.map((bank) => {
      return { value: bank.COMPE, label: bank.LongName }
    }))
  }, [banks, bank])

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post("retailers/create", {
        retailer: {
          email,
          password,
          password_confirmation,
          name,
          cpf,
          cep,
          phone,
          rg,
          person_type,
          cnpj,
          fantasy_name,
          social_name,
          icms_contribution,
          national_simple, //bolean
          state_registration,
          municipal_registration,
          bank,
          branch_number,
          branch_check_digit,
          account_number,
          account_check_digit,
          account_type,
          ddd,
          street,
          street_number,
          city,
          state,
          neighborhood,
        }
      });
      if (response.data) {
        alert("Revendedor criado.", 'success');
        history.push("/login");
      }    
    } catch (error) {
      alert('Erro, tente novamente.','error');
    }
  }

  function onBlurCep(event) {
    const { value } = event.target;
    const cep = value?.replace(/[^0-9]/g, "");

    if (cep?.length !== 8) {
      return;
    }
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json()) // Retorna o json da api viacep
      .then((data) => {
        setDdd(data.ddd)
        setState(data.uf)
        setCity(data.localidade)
        setNeighborhood(data.bairro)
        setStreet(data.logradouro)
      });
  }

  return (
    <Container>
      <h1>Quero me tornar um revendedor Vai de Férias</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-1">
          <div className="sub-form-left">
            <div className='title-1'>
              <h2>Preencha seus dados abaixo</h2>
            </div>
          </div>
          <div className="sub-form"></div>
        </div>
        <div className="form-1">
          <div className="select_input">
            <div className='select'>
              <Select 
                options={options_person_type} placeholder="Tipo de Pessoa"
                defaultValue= {options_person_type[0]}
                onChange={(value) => setPerson_type(value?.value)}
              /> 
            </div>
            
          </div>
          <div className="sub-form">
          { person_type === 'individual' || person_type === null ? 
          <>
            <Input
              placeholder="Nome Completo"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </> 
          : 
          <>
            <MaskInput
              mask="99.999.999/999-99"
              placeholder="CNPJ"
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value)}
              required
            />
          </> }
          </div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <Input
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              Icon={MdEmail}
              required
            />
          </div>
          <div className="sub-form">
            <MaskInput
              mask='(99)'
              placeholder='DDD'
              value={ddd}
              onChange={(e) => setDdd(e.target.value)}
              name='ddd'
              format='ddd'
              type="tel"
              required
            />
            <MaskInput
              mask="99999-9999"
              placeholder="Telefone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              Icon={MdPhone}
              format="phone"
              type="tel"
              required
            />
          </div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <Input
              placeholder="Senha"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              Icon={MdLock}
              required
            />
          </div>
          <div className="sub-form">
            <Input
              placeholder='Cidade'
              value={city}
              onChange={(e) => setCity(e.target.value)}
              name='localidade'
              format='city'
              required
            />
            <div className="select_input_right_2">
              <div className='select'>
                <Select
                  options={optionStates} isSearchable placeholder="Estado"
                  onChange={(value) => setState(value?.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <Input
              placeholder="Confirmar Senha"
              type="password"
              value={password_confirmation}
              onChange={(e) => setPassword_confirmation(e.target.value)}
              Icon={MdLock}
              required
            />
          </div>
          <div className="sub-form">
            <MaskInput
              mask="99999-999"
              placeholder="CEP"
              onBlur={onBlurCep}
              value={cep}
              onChange={(e) => setCep(e.target.value)}
              type="tel"
              format='cep-sm'
              required
            />
            <Input
              placeholder='Bairro'
              name='bairro'
              value={neighborhood}
              onChange={(e) => setNeighborhood(e.target.value)}
              format='district'
              required
            />
          </div>
        </div>
        <div className='form-1'>
          <div className="sub-form-left">
            { person_type === 'individual' ? 
            <>
              <MaskInput
                mask="999.999.999-99"
                placeholder='CPF'
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                name='cpf'
                format='esquerda_50'
                required
              />
              <Input
                placeholder='RG'
                name='rg'
                value={rg}
                onChange={(e) => setRg(e.target.value)}
                format='direita_50'
                required
              />
            </>
            : 
            <>
              <div className="select_input_2">
                <div className='select'>
                  <Select 
                    options={options_icms_contribution} placeholder="Contribuição ICMS"
                    onChange={(value) => changeICMStype(value?.value)}
                  />
                </div>
              </div>
              { icms_contribution === 'Contribuinte ICMS' ?
                <div className='checkbox'>
                  <input id='nacional' value={national_simple} type="checkbox" onChange={(e) => setNational_simple(e.target.checked)}/>
                  <label for='nacional'>Simples Nacional</label>
                </div>
              : 
                <div className='checkbox'>
                  <input checked={false} type="checkbox" disabled={true}/>
                  <label>Simples Nacional</label>
                </div>
              }

            </> }
          </div>
          <div className='sub-form'>
            <Input
              placeholder='Rua'
              value={street}
              onChange={(e) => setStreet(e.target.value)}
              name='logradouro'
              format='street'
              required
            />
            <Input
              placeholder='Número'
              value={street_number}
              onChange={(e) => setStreet_number(e.target.value)}
              name='numero'
              format='number'
              required
            />
          </div>
        </div>
        { person_type === 'company' ? 
          <> 
            <div className='form-1'>
              <div className="sub-form-left">
                <Input
                  placeholder='Razão Social'
                  value={social_name}
                  onChange={(e) => setSocial_name(e.target.value)}
                  format='esquerda_50'
                />
                <Input
                  placeholder='Nome Fantasia'
                  value={fantasy_name}
                  onChange={(e) => setFantasy_name(e.target.value)}
                  format='direita_50'
                />
              </div>
              <div className='sub-form'>
                <Input
                  placeholder='Inscrição Estadual'
                  value={state_registration}
                  onChange={(e) => setState_registration(e.target.value)}
                  format='esquerda_50'
                  required
                />
                { state !== 'DF' ?
                  <Input
                    placeholder='Inscrição Municipal'
                    value={municipal_registration}
                    onChange={(e) => setMunicipal_registration(e.target.value)}
                    format='direita_50'
                  />
                : 
                  <Input
                    placeholder='Inscrição Municipal'
                    value=''
                    disabled
                    format='direita_50'
                    cursor='not-allowed'
                  />
                }
              </div>
            </div>
          </>
        : 
        null }
        <div className="form-1">
          <div className="sub-form-left">
            <div className='title-2'>
              <h2>Preencha seus dados bancarios</h2>
            </div>
          </div>
          <div className="sub-form"></div>
        </div>
        <div className="form-1">
          <div className="select_input">
            <div className='select'>
              <Select 
                options={options_bank} placeholder="Banco"
                onChange={(value) => setBank(value?.value)}
              /> 
            </div>
          </div>
          <div className="select_input_right">
            <div className='select'>
              <Select 
                options={options_account_type} placeholder="Tipo da conta"
                onChange={(value) => setAccount_type(value?.value)}
              /> 
            </div>
          </div>
        </div>
        <div className="form-1">
          <div className="sub-form-left">
            <Input
              placeholder="Agência"
              value={branch_number}
              onChange={(e) => setBranch_number(e.target.value)}
              format="street"
              required
            />
            <Input
              placeholder="Dígito"
              value={branch_check_digit}
              onChange={(e) => setBranch_check_digit(e.target.value)}
              format="number"
              required
            />
          </div>
          <div className="sub-form">
            <Input
              placeholder="Número da Conta"
              value={account_number}
              onChange={(e) => setAccount_number(e.target.value)}
              format="street"
              required
            />
            <Input
              placeholder="Dígito"
              value={account_check_digit}
              onChange={(e) => setAccount_check_digit(e.target.value)}
              format="number"
              required
            />
          </div>
        </div>
        <div className="div_button">
          <div className="button">
            <Button type="submit" format="submit">Criar Conta</Button>
          </div>
        </div>
      </form>
      
    </Container>
  );
};

export default RetailerCreate;
